<app-header></app-header>
<router-outlet (activate)="onActivate($event)"></router-outlet>
<div>
  <app-new-footer></app-new-footer>
</div>


<!-- <div class="modal fade bd-example-modal-sm" id="myModal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-sm modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Registration Form</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <a href="" target="_blank" class="btn">MPPS Sector 7</a>
            <a href="https://data.odpay.in/odforms/form/MaharanaPratapPublicSchoolRegistrationForm202223/formperma/3Ip6FXbdEj0-YzpNeU2T8ZPZ4yiTDKNMuO2Vx2SDoRQ" target="_blank" class="btn ml-3">MPPS City Branch</a>
          
        </div>
        <div id="popupCarousel" class="carousel slide" data-ride="carousel">
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img class="d-block w-100" src="/assets/img/popup/2.jpg" alt="First slide">
            </div>
            <div class="carousel-item">
              <img class="d-block w-100" src="/assets/img/popup/3.jpg" alt="Second slide">
            </div>
            <div class="carousel-item">
              <img class="d-block w-100" src="/assets/img/popup/4.jpg" alt="Third slide">
            </div>
          </div>
          <a class="carousel-control-prev" href="#popupCarousel" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#popupCarousel" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div> -->
<!-- <div class="modal " id="myModal" tabindex="-1" role="dialog" >
    <div class="modal-dialog modal-dialog-centered modal-sm  " style="width: 800px !important;" role="dialog">
      <div class="modal-content">
        <div class="modal-header">
            <h5>Registration </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <div class="mb-3">
                <a href="" target="_blank" class="btn">MPPS Sector 7</a>
                <a href="https://data.odpay.in/odforms/form/MaharanaPratapPublicSchoolRegistrationForm202223/formperma/3Ip6FXbdEj0-YzpNeU2T8ZPZ4yiTDKNMuO2Vx2SDoRQ" target="_blank" class="btn ml-3">MPPS City Branch</a>
            </div>
          <img src="/assets/img/popup/1.jpg" alt="Admission Open" class="img-fluid rounded " >
        </div>
      </div>
    </div>
  </div> -->



  <!-- 
      <iframe frameborder="0" style="height:500px;width:99%;border:none;" src='https://data.odpay.in/odforms/form/MaharanaPratapPublicSchoolRegistrationForm202223/formperma/3Ip6FXbdEj0-YzpNeU2T8ZPZ4yiTDKNMuO2Vx2SDoRQ'></iframe>
   -->